import { render } from "./SwiperPacientes.vue?vue&type=template&id=20a921c6&scoped=true"
import script from "./SwiperPacientes.vue?vue&type=script&lang=js"
export * from "./SwiperPacientes.vue?vue&type=script&lang=js"

import "./SwiperPacientes.vue?vue&type=style&index=0&id=20a921c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a921c6"]])

export default __exports__